import axios from "axios";

// @ts-ignore
const { nonce } = window.adminOrderSmsAppContext || {};

const axiosConn = axios.create({
	baseURL: '',
	headers: {
		Accept: "application/json",
		"X-WP-Nonce": nonce,
	},
});

export const sendMessage = async (
	phone: string,
	message: string,
	orderNumber: number,
) => {
	return axiosConn.post("/wp-json/messageflow/v1/send-sms", {
		"to-phone-number": phone,
		message: message,
		"order-number": orderNumber,
	});
};

export const updateSmsSubscription = async (orderNumber: number) => {
	const response = await axiosConn.post(
		"/wp-json/messageflow/v1/sms-subscribe",
		{
			"order-number": orderNumber,
		},
	);

	return response;
};

export const getSmsSubscription = async (orderNumber: number) => {
	const response = await axiosConn.get(
		`/wp-json/messageflow/v1/sms-subscribe?order-number=${orderNumber}`,
	);
	return response;
};